<template>
  <NotificationsList :skip-notifs-limit="true" :is-notification-page="true" />
</template>

<script lang="ts" setup>
import { watch } from 'vue';
import { NotificationsList } from '~/components/lib/notifications';
import { useStoreModals } from '~/stores/abstract/modals';
import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import type { ComponentInfoPageBlocksNotificationsBlock } from '~/types/infoPages';

defineProps({
  data: {
    type: Object as PropType<ComponentInfoPageBlocksNotificationsBlock>,
    required: true,
  },
});

const storeSsPlayer = useStoreSsPlayer();
const storeRoot = useStoreRoot();
const storeModals = useStoreModals();

watch(
  () => storeSsPlayer.isPlayerAuthorised,
  async () => {
    if (!storeSsPlayer.isPlayerAuthorised) {
      await navigateTo({ path: storeRoot.localePath('/') });
    }
  }
);
onBeforeMount(async () => {
  if (!storeSsPlayer.isPlayerAuthorised) {
    await navigateTo({ path: storeRoot.localePath('/') });
    storeModals.openLoginOrSignupModal();
  }
});
</script>

<style lang="scss" src="./notificationBlock.scss"></style>
